import { render } from "./Step2Delivery.vue?vue&type=template&id=04db9c00"
import script from "./Step2Delivery.vue?vue&type=script&lang=js"
export * from "./Step2Delivery.vue?vue&type=script&lang=js"

import "./Step2Delivery.vue?vue&type=style&index=0&id=04db9c00&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__